import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { countriesAvailabilityBasedPeriodAndPg } from '@state/feature/availability-country/AvailabilityCountrySlice';
import { getSubscribeCountries, getUnavailableCountryByPGsByPeriod } from '../../CountryUtils';
import { CountryFilterPair, CountryMasterPgsFilterPair, Option } from '../../pageConfig/Types';

export interface CountryAvailabilityProps {
  periodValue: string;
  periodicity: Periodicity;
  appliedProductGroups?: Option[];
  appliedCountries?: Option[];
  pgsByAppliedCountry: CountryFilterPair[];
  masterPgsByCountry: CountryMasterPgsFilterPair[];
  isWeeklyMatYtdNonLocalCurrency: boolean;
}

export const useDispatchCountriesAvailability = ({
  periodValue,
  periodicity,
  appliedProductGroups,
  appliedCountries,
  pgsByAppliedCountry,
  masterPgsByCountry,
  isWeeklyMatYtdNonLocalCurrency,
}: CountryAvailabilityProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const subscribedCountries = getSubscribeCountries(
      periodicity,
      pgsByAppliedCountry,
      appliedCountries,
      appliedProductGroups,
    );
    const unavailableCountriesByPeriodAndPg = !isWeeklyMatYtdNonLocalCurrency
      ? getUnavailableCountryByPGsByPeriod(
          periodValue,
          periodicity,
          masterPgsByCountry,
          subscribedCountries,
          appliedProductGroups,
        )
      : [];

    dispatch(
      countriesAvailabilityBasedPeriodAndPg({
        periodicity,
        periodValue,
        subscribedCountries,
        unavailableCountriesByPeriodAndPg,
      }),
    );
  }, [
    periodValue,
    periodicity,
    pgsByAppliedCountry,
    masterPgsByCountry,
    appliedProductGroups,
    appliedCountries,
    isWeeklyMatYtdNonLocalCurrency,
  ]);
};
